module.exports = __webpack_public_path__ + "static/media/YF85_06.0666f557.jpg";